module.exports = __webpack_public_path__ + "static/media/mammograms-save-lives.19599177.png";